export default __webpack_public_path__ + "static/media/showroom46.516197ed.webp";